
  export const WAITLISTS_RECEIVED = "WAITLISTS_RECEIVED";
  export const SET_WAITLIST = "SET_WAITLIST";
  export const CREATE_WAITLIST = "CREATE_WAITLIST";
  export const SET_PROPERTY_WAITLIST = "SET_PROPERTY_WAITLIST";
  